import { TypographyXS } from "@/components/typography/XS";
import { Button } from "@/components/ui/button";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { useClientReleaseCheck } from "../hooks/clientReleaseCheck";
import { ReleaseNotes } from "./ReleaseNotes";

const ClientRelease = () => {
  const { displayReleaseNotes, prevVersionId, newReleaseAvailable } =
    useClientReleaseCheck();
  const [openReleaseNotesModal, setOpenReleaseNotesModal] = useState(true);

  return (
    <>
      <AnimatePresence>
        {displayReleaseNotes && openReleaseNotesModal && (
          <ReleaseNotes
            onOpenChange={setOpenReleaseNotesModal}
            prevVersionId={prevVersionId}
          />
        )}
      </AnimatePresence>
      {newReleaseAvailable && (
        <motion.div
          className="absolute z-50 bottom-2 left-[66px] flex items-center gap-3 rounded-md py-2 px-2.5 bg-brand-primary"
          initial={{ bottom: "0", opacity: 0 }}
          animate={{ bottom: "8px", opacity: 1 }}
        >
          <TypographyXS className="font-medium">
            New version available
          </TypographyXS>
          <Button
            variant="default"
            size="sm"
            onClick={() => window.location.reload()}
          >
            Update
          </Button>
        </motion.div>
      )}
    </>
  );
};

export default ClientRelease;
